/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */
import Lottie from 'lottie-react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import { Skeleton } from '../../../../common/ui/components/skeleton';
import { useThemeAnimation } from '../../../../common/ui/utils/use-theme-animation';

const styles = cssMap({
	backgroundAnimation: {
		display: 'none',
		'@media (min-width: 64rem)': {
			display: 'block',
			position: 'absolute',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			zIndex: 0,
			pointerEvents: 'none',
			width: '968px',
		},
	},
});

const loadLightAnimation = () => {
	return import(
		/* webpackChunkName: "provisioning-background-light" */
		'../../assets/provisioning.light.json'
	);
};

const loadDarkAnimation = () => {
	return import(
		/* webpackChunkName: "provisioning-background-dark" */
		'../../assets/provisioning.dark.json'
	);
};

export const ProvisioningAnimations = (): JSX.Element => {
	const backgroundAnimation = useThemeAnimation(loadLightAnimation, loadDarkAnimation);

	return (
			<Box xcss={styles.backgroundAnimation}>
				<Skeleton isLoading={!backgroundAnimation}>
					<Lottie animationData={backgroundAnimation} loop={false} />
				</Skeleton>
			</Box>
	);
};
